<template>
  <div>
    <b-modal
      id="saveManualPayment"
      title="تسویه دستی"
      ok-title="ذخیره"
      cancel-title="لغو"
      @ok="SaveManual"
    >
      <b-form-group label="حساب مقصد:">
        <v-select-shepa
          dir="rtl"
          :options="usercards"
          :reduce="(item) => item.value"
          label="text"
          :value="manualItem.detailed_id"
          v-model="manualItem.detailed_id"
          :dropdown-should-open="dropdownShouldOpen"
          :autocomplete="'on'"
        ></v-select-shepa>
        <!-- <v-select-shepa
          style="width: calc(100% - 60px)"
          dir="rtl"
          :options="userCards"
          :reduce="(item) => item.value"
          label="text"
          :value="manualItem.detailed_id"
          v-model="manualItem.detailed_id"
          :dropdown-should-open="dropdownShouldOpen"
          :autocomplete="'on'"
        ></v-select-shepa> -->
      </b-form-group>
      <b-form-group label="مبلغ:">
        <NumberSeprator v-model="manualItem.amount"></NumberSeprator>
      </b-form-group>
      <b-form-group label="حساب مبدا:">
        <b-form-select
          v-model="manualItem.bank_detailedid"
          :options="banks"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="کد رهگیری:">
        <b-form-input v-model="manualItem.tracking_number"></b-form-input>
      </b-form-group>
    </b-modal>
    <b-modal id="manualCharge" title="شارژ دستی">
      <b-form-group label="تاریخ:">
        <date-picker
          display-format="jYYYY/jMM/jDD"
          format="jYYYY/jMM/jDD"
          clearable
          v-model="manualCharge.date"
        ></date-picker>
      </b-form-group>

      <b-form-group label="کد رهگیری:">
        <b-form-input v-model="manualCharge.referenceNumber"></b-form-input>
      </b-form-group>
      <template #modal-footer>
        <b-button
          variant="danger"
          @click="$bvModal.hide('manualCharge'), (isBusyCharge = false)"
        >
          لغو
        </b-button>
        <b-button
          variant="success"
          @click="ChargeManual"
          :class="isBusyCharge ? 'spinner spinner-light spinner-right' : ''"
        >
          پرداخت
        </b-button>
      </template>
    </b-modal>
    <b-modal id="melli_manualCharge" title="شارژ دستی بانک ملی">
      <b-form-group label="کد رهگیری:">
        <b-form-input
          v-model="melli_manualCharge.referenceNumber"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="مبلغ:">
        <b-form-input v-model="melli_manualCharge.amount"></b-form-input>
      </b-form-group>
      <template #modal-footer>
        <b-button
          variant="danger"
          @click="$bvModal.hide('melli_manualCharge'), (isBusyCharge = false)"
        >
          لغو
        </b-button>
        <b-button
          variant="success"
          @click="melli_manualCharge_fn"
          :class="isBusyCharge ? 'spinner spinner-light spinner-right' : ''"
        >
          پرداخت
        </b-button>
      </template>
    </b-modal>
    <b-card>
      <b-tabs nav-wrapper-class="w-100">
        <b-tab title="بستانکاران سرویس تسهیم" active>
          <list-table
            :url="url"
            title=""
            :fields="fields"
            :params="params"
            :sumPrice="true"
            :btns="btns"
            :back="false"
          ></list-table>
        </b-tab>
        <b-tab title="بستانکاران درگاه واسط">
          <IndirectCreditorsList />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_BANK_LIST } from "@/core/services/store/getBankList.module";
import httpHelper from "../../helpers/httpHelper";
import TableShowData from "../../components/table";
import IndirectCreditorsList from "./IndirectGateway/IndirectCreditorsList";
import NumberSeprator from "../../components/numberSeprator";

export default {
  name: "creditors",
  data() {
    return {
      isBusyCharge: false,
      url: "creditors",
      transactions_created_at: "",
      totlaBalanc: 0,
      usercards: [],
      banks: [],
      gatewayId: 0,
      manualItem: {
        detailed_id: 0,
        amount: 0,
        bank_detailedid: 0,
        tracking_number: "",
      },
      manualCharge: {
        date: null,
        referenceNumber: "",
        api: "",
      },
      melli_manualCharge: {
        referenceNumber: "",
        api: "",
        amount: 0,
      },
      //anotherUrl:{SAD:'saderat/get-balance',SAM:'saman/deposit-balance'},
      params: [
        {
          label: "موجودی بانک سامان",
          field: "BalanceSaman",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک سامان 2",
          field: "BalanceSaman2",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات",
          field: "BalanceSaderat",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک ملی",
          field: "BalanceMeli",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی بانک صادرات 4000 (ریال) :",
          field: "BalanceSaderat4000",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "موجودی کل:",
          field: "TotalBalance",
          type: "text",
          value: "",
          disabled: true,
        },
        {
          label: "تا تاریخ",
          field: "date",
          type: "date-picker",
          value: "",
        },
        {
          label: "تا ساعت",
          field: "time",
          type: "text",
          value: "",
        },
      ],
      fields: [
        {
          key: "gateway.user.name",
          label: "نام پذیرنده",
        },

        {
          key: "gateway.website",
          label: "وب سایت",
        },
        {
          key: "amount",
          label: "مانده حساب (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "status",
          label: "وضعیت",
          formatter: (value, key, item) => {
            if (item.amount < 0) {
              return "بدهکار";
            } else {
              return "بستانکار";
            }
          },
        },
        // {
        //   key: "btns",
        //   label: "عملیات",
        // },
      ],
      btns: [
        {
          icon: "card-checklist",
          title: "تسویه دستی",
          handler: (e) => {
            httpHelper
              .getData("usercards/?user_id=" + e.gateway.user.id)
              .then((res) => {
                this.usercards = res.result.map((element) => {
                  return {
                    text: element.nickname + "(" + element.shaba_number + ")",
                    value: element.detailed[0].id,
                  };
                });

                this.gateway_user_id = e.gateway.user.id;
                this.gatewayId = e.gateway.id;
                this.$bvModal.show("saveManualPayment");
              });
          },
        },
        {
          icon: "credit-card",
          title: "شارژ دستی",
          handler: (e) => {
            Object.assign(this.manualCharge, { api: e.gateway.pin });
            this.$bvModal.show("manualCharge");
          },
        },
        {
          icon: "credit-card",
          title: "شارژ دستی بانک ملی",
          handler: (e) => {
            Object.assign(this.melli_manualCharge, { api: e.gateway.pin });
            this.$bvModal.show("melli_manualCharge");
          },
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    IndirectCreditorsList,
    "v-select-shepa": vSelect,
    NumberSeprator,
  },
  watch: {
    totlaBalanc(newB, oldB) {
      this.params[5].value = Number(newB).toLocaleString() + " ریال";
    },
  },
  props: ["hasconfig"],
  computed: {
    // loadedBankList() {
    //   return this.$store.getters.loadedBankList;
    // },
  },
  methods: {
    dropdownShouldOpen(VueSelect) {
      if (this.manualItem.detailed_id == 0) {
        // .getData("usercards/?user_id=" + e.gateway.user.id)
        httpHelper
          .getData(
            "usercards?user_id=" + this.gateway_user_id + "&iban=" + VueSelect.search
          )
          .then((response) => {
            this.usercards = response.result
              .filter(function (o) {
                return o.detailed.length > 0;
              })
              .map((item) => {
                return {
                  text: item.shaba_number + " (" + item.nickname + ")",
                  value: item.detailed[0].id,
                };
              });
          });
      }
      return VueSelect.open;
    },
    SaveManual() {
      httpHelper
        .postData(
          "sharing/save_manual_transfer/" + this.gatewayId,
          this.manualItem
        )
        .then((res) => {
          this.url = "creditors?t=" + new Date().getTime();
        });
      this.$bvModal.hide("saveManualPayment");
    },
    loadedBalanceSam() {
      this.$store.dispatch(GET_BANK_LIST).then((loadedBankList) => {
        this.banks = loadedBankList.map((element) => {
          return {
            text: element.text,
            value: element.value,
          };
        });
        loadedBankList.forEach((element, index) => {
          httpHelper
            .getData(`sharing/get_balance/${element.title}`)
            .then((res) => {
              if (!res.result.url.match("https://")) {
                this.totlaBalanc += res.result.balance;
                this.params[index].value =
                  Number(res.result.balance).toLocaleString() + " ریال";
              } else {
                this.$makeToast(
                  "danger",
                  "مشاهده موجودی بانک ملی",
                  "برای مشاهده موجودی اینجا کلیک کنید.",
                  7000,
                  res.result.url
                );
              }
            });
        });
      });
    },
    ChargeManual() {
      this.isBusyCharge = true;
      httpHelper
        .postData("deposit-statement", this.manualCharge)
        .then((res) => {
          if (res.success) {
            this.$bvModal.hide("manualCharge");
            this.url = "creditors?t=" + new Date().getTime();
            this.$makeToast(
              "success",
              "شارژ موفق",
              `شارژ با موفقیت انجام شد.`,
              7000
            );
          } else {
            this.$makeToast("danger", "خطا", res.error, 7000);
          }
          this.isBusyCharge = false;
        });
    },
    melli_manualCharge_fn() {
      this.isBusyCharge = true;
      httpHelper
        .postData("deposit-statement-melli", this.melli_manualCharge)
        .then((res) => {
          if (res.success) {
            this.$bvModal.hide("melli_manualCharge");
            this.url = "creditors?t=" + new Date().getTime();
            this.$makeToast(
              "success",
              "شارژ موفق",
              `شارژ با موفقیت انجام شد.`,
              7000
            );
          } else {
            this.$makeToast("danger", "خطا", res.error, 7000);
          }
          this.isBusyCharge = false;
        });
    },
    // getBankList(){
    //   ;
    // }
  },
  mounted() {
    if (this.hasconfig == null) {
      this.fields.push({
        key: "btns",
        label: "عملیات",
      });
    }
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "بستانکاران سرویس تسهیم" }]);
    // httpHelper.getData("sharing/banks").then((res) => {
    //   this.banks = res.result.map((element) => {
    //     return {
    //       text: element.fa_title,
    //       value: element.detail_id,
    //     };
    //   });
    // });
    this.loadedBalanceSam();
  },
};
</script>
